import React from 'react'
import MyButton from '../../../../../components/UI/button/MyButton'
import GlassEffect from '../GlassEffect/GlassEffect'

export default function ModelCard({ img, title, text, handleClick, source }) {
    const children = <div className="landing-model-card" onClick={() => handleClick(source)}>
        <img src={`${process.env.REACT_APP_BASENAME}/img/${img}`} alt="" />
        <div className="landing-model-card-info">
            <h3 dangerouslySetInnerHTML={{ __html: title }}></h3>
            <p>{text}</p>
            <MyButton buttonText={'Try it'} />
        </div>
    </div>
    return (
        <div style={{ position: 'relative' }}>
            <GlassEffect children={children} />

        </div>

    )
}
